<template>
  <b-modal
    :id="`modal-details-${file.idAprobacion}`"
    :title="`Detalles del flujo Nº ${file.numero}`"
    ok-title="Vale"
    @ok="handleOk"
    size="lg"
    ref="my-modal"
    ok-only
  >
    <div class="row" v-if="fileOnFlow.detalle.ejecucion">
      <div class="col-12">
        <h4
          v-if="fileOnFlow.detalle && fileOnFlow.detalle.documentosBase
           && fileOnFlow.detalle.documentosBase.length"
        >
          Detalles del Flujo para el
          documento {{fileOnFlow.detalle.documentosBase[0].objetoNombre}}
        </h4>
        <div class="text-primary">
          {{fileOnFlow.detalle.ejecucion.descripcion}}
        </div>
      </div>
      <div class="col-12">
        <div class="row mb-3">
          <h5 class="col-12 mt-4">
            Archivos adjuntos
          </h5>
          <vs-table
            style="width: 100%;"
            stripe
            :data="(orderedFiles || [])"
            noDataText="No hay archivos adjuntos"
          >
            <template slot="header">
            </template>
            <template slot="thead">
              <vs-th v-if="isConvention">
                Nombre documento
              </vs-th>
              <vs-th>
                Nombre Adjunto
              </vs-th>
              <vs-th>
                Tipo
              </vs-th>
              <vs-th>
                Ver
              </vs-th>
            </template>
            <template>
              <tbody>
              <vs-tr
                v-for="attachment in orderedFiles"
                :key="attachment.url"
              >
                <vs-td v-if="isConvention">
                  {{ attachment.nombre }}
                </vs-td>
                <vs-td>
                  {{ attachment.nombreCompleto }}
                </vs-td>
                <vs-td>
                 <span v-if="attachment.tipo">
                    {{attachment.tipo}}
                  </span>
                </vs-td>
                <vs-td>
                  <span
                    v-on:click="selectFile(attachment)"
                    style="cursor:pointer;width: fit-content;"
                  >
                     <feather-icon icon="FileTextIcon" size="14" />
                  </span>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
        <div class="">
          <div class="col-6">
            <pdf
              class="mt-2"
              v-for="i in numPages"
              :key="i"
              :page="i"
              :src="selectedFile"
            />
          </div>
        </div>
      </div>
      <div class="col-6">
        <h5 class="my-3">
          Pasos
        </h5>
        <Steps
          v-if="fileOnFlow.detalle && fileOnFlow.detalle.pasos"
          :steps="fileOnFlow.detalle.pasos"
          :ejecucion="fileOnFlow.detalle.ejecucion"
          :show-participants="true"
        />
      </div>
      <div class="col-6">
        <h5 class="my-3">
          Bitácora
        </h5>
        <div v-if="loadingBinnacle">
          <b-spinner variant="primary"/>
        </div>
        <binnacle v-else-if="binnacleFile.length" />
      </div>
    </div>
  </b-modal>
</template>
<script>

import { BModal, VBModal } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { mapGetters } from 'vuex';

import { rolTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import Steps from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Steps';
import Binnacle from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Binnacle';

export default {
  components: {
    BModal,
    Steps,
    Binnacle
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      stepTypes: StepTypes,
      selectedFile: '',
      numPages: undefined
    };
  },
  props: [
    'file'
  ],
  computed: {
    ...mapGetters('Approvals', [
      'binnacleFile',
      'loadingBinnacle',
      'fileOnFlow',
      'fileOnFlowAttachments'
    ]),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isOffice() {
      const { pasos } = this.fileOnFlow.detalle;
      const { ejecucion } = this.fileOnFlow.detalle;
      return (pasos || [])
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && step.paso.aprobacionesTipoPasoId === this.stepTypes.OFFICE.toString()
        ));
    },
    isSigner() {
      const { pasos } = this.fileOnFlow.detalle;
      const { ejecucion } = this.fileOnFlow.detalle;
      return (pasos || [])
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && step.paso.aprobacionesTipoRolId === rolTypesCode.firmante
        ));
    },
    stepId() {
      const { pasos } = this.fileOnFlow.detalle;
      const { ejecucion } = this.fileOnFlow.detalle;
      return this.fileOnFlow.detalle && (pasos || [])
        .find((step) => step.id === ejecucion.pasoActualId);
    },
    canReturn() {
      const { ejecucion } = this.fileOnFlow.detalle;
      const { pasos } = this.fileOnFlow.detalle;
      const actualStep = (pasos || [])
        .find((step) => step.id === ejecucion.pasoActualId);
      const { reversible } = ejecucion;
      const isTemporal = actualStep.esTemporal;
      const returnStep = actualStep.numeroPaso.toString() !== '1' && reversible && !isTemporal;
      return returnStep;
    },
    orderedFiles() {
      const iniciales = this.fileOnFlowAttachments.filter((f) => f.esInicial);
      const noIniciales = this.fileOnFlowAttachments.filter((f) => !f.esInicial)
        .sort((a, b) => {
          if (!a.fecha) return 1;
          if (!b.fecha) return -1;
          return new Date(a.fecha) - new Date(b.fecha);
        });
      return [...iniciales, ...noIniciales];
    }
  },
  methods: {
    selectFile(file) {
      console.log(this.fileOnFlow);
      const currentUserId = this.currentUser.id;
      const authorFlowId = this.fileOnFlow.detalle.ejecucion.usuarioId;
      const currentUserInSteps = this.fileOnFlow.detalle.pasos
        .some((step) => step.paso.tipoValorResponsableId === currentUserId
          // eslint-disable-next-line max-len
          || step.paso.grupoUsuarios?.some((user) => user.tipoValorResponsableId === currentUserId));

      if (this.fileOnFlow.detalle.ejecucion.privado === 'Y') {
        if (currentUserId === authorFlowId || currentUserInSteps) {
          return window.open(file.url, '_blank');
        }
        return this.$bvToast.toast(
          'El flujo para este documento está marcado como privado',
          {
            title: '¡Oops!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
      return window.open(file.url, '_blank');
    },
    handleOk() {
      this.$nextTick(() => {
        this.$refs['my-modal'].hide();
      });
    }
  }
};
</script>
<style>
.box-attachments {
  max-height: 300px;
  overflow-y: auto;
}
</style>
